import React from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'

import './ContentBlocks.css'

const ContentBlockImage = (props) => (
  <div className={'content-block with-image '+props.align}>
    <div className="container">
      <div className="image">{props.fields.image && <div style={{backgroundImage: 'url('+props.fields.image[0].fields.file.url+')'}} />}</div>
      <div>
        {props.fields.topHeading && <div className="subheading">{props.fields.topHeading}</div>}
        {props.fields.heading && <h2>{props.fields.heading}</h2>}

        <div className="lead">
          {props.fields.lead && <ReactMarkdown source={props.fields.lead} softBreak="br" />}
        </div>

        <div className="content">
          {props.fields.content && <ReactMarkdown source={props.fields.content} softBreak="br" />}
        </div>

        {(props.fields.leadLinkText && (props.fields.leadInternalLink || props.fields.leadLinkUrl)) && <a href={props.fields.leadInternalLink ? props.fields.leadInternalLink.fields.slug : props.fields.leadLinkUrl} className="btn">{props.fields.leadLinkText}</a>}
      </div>
    </div>
  </div>
)

ContentBlockImage.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ContentBlockImage)



// WEBPACK FOOTER //
// ./src/components/ContentBlocks/ContentBlockImage.js